<template>
  <div>
    <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='新闻分类QC配置'; type=1 ; }"> 新闻分类QC配置
    </a-button>
    <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='聚合页面QC配置'; type=2 ; }" > 聚合页面QC配置</a-button>


    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" >
      <span slot="use_qc_slug" slot-scope="text, record" :title="text">
        <span v-if="text==1">是</span>
        <span v-else>否</span>
      </span>
      <span slot="watermark" slot-scope="text, record" :title="text">
        <span v-if="text==1">是</span>
        <span v-else>否</span>
      </span>
      <span slot="release" slot-scope="text, record" :title="text"  >
        <span v-if="text==1">是</span>
        <span v-else>否</span>
      </span>
      <span slot="action" slot-scope="text, record">
          <a @click="(record)=>{visibleForm = true;  titleForm='编辑QC配置'; editId=text.id ; }" >编辑</a>
          <a-popconfirm
              title="是否删除 删除后，将无法再同步文章数据"
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirm(record)"
              @cancel="()=>{}"
          >
           <a><a-divider type="vertical"/>删除</a>
          </a-popconfirm>
          <a @click="openQc2Link(record)"><a-divider type="vertical"/>获取QC2参数</a>
          <a @click="openQc3Link(record)"><a-divider type="vertical"/>获取QC3参数</a>
      </span>

    </a-table>
    <IndustryForm :visible="visibleForm" :title="titleForm" :editId="editId" :type="type" :a_customer_id = this.$route.query.id
                  @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>
  </div>

</template>

<script>
import API from "./api";
import IndustryForm from "./components/industryForm"
const columns = [
  {
    title: "新闻分类",
    dataIndex: "category_name",
    ellipsis: true,
    key: "category_name",
  },
  {
    title: "网站语种",
    dataIndex: "lang_name",
    ellipsis: true,
    key: "lang"
  },
  {
    title: "是否适用QC生成URL",
    key: "use_qc_slug",
    ellipsis: true,
    dataIndex: "use_qc_slug",
    scopedSlots: {customRender: "use_qc_slug"}
  },
  {
    title: "是否生成水印",
    key: "watermark",
    ellipsis: true,
    dataIndex: "watermark",
    scopedSlots: {customRender: "watermark"}
  },
  {
    title: "是否发布",
    key: "release",
    ellipsis: true,
    dataIndex: "release",
    scopedSlots: {customRender: "release"}
  },
  {
    title: "创建时间",
    key: "create_time",
    ellipsis: true,
    dataIndex: "create_time",
  },
  {
      title: "操作",
      key: "action",
      width: "240px",
      scopedSlots: {customRender: "action"}
  }
];
export default {
  name: 'Industry',
  data() {
    return {
      visibleForm: false,
      titleForm: "",
      loading: true,
      editId: null,
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      data: [],
      columns,
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/CustomerManagement/QcConfig"; //设置左侧导航2-2 active
  },
  components: {IndustryForm},
  methods: {
    getList(page) {
      API.service.GET_LIST({ page: page || 1, a_customer_id :this.$route.query.id}).then(res => {
        this.data = res.data.data.data
        this.loading = false
        this.pagination.total = res.data.data.total
        this.pagination.pageSize = res.data.data.per_page
        this.pagination.current = res.data.data.current_page
      })
      // API.service.GET_NEWS_CATEGORY({ custom_id :this.$route.query.id}).then(res => {
      //
      // })
      // API.service.GET_DETAILS({  custom_id :this.$route.query.id}).then(res => {
      //
      // })

    },
    confirm(row) {
      API.service.DELE({ids: [row.id]}).then(res => {
        if (res.data.code == 200) {
          this.getList()
        }
      })
    },
    openQc2Link(row) {
      API.service.GET_LINK2({id: row.id, a_customer_id: row.a_customer_id}).then(res => {
        if (res.data.code == 1) {
          navigator.clipboard.writeText( res.data.data.link)
          console.log(res.data.data.link)
          this.$message.success("参数已复制");
        }else{
          this.$message.error("获取失败");
        }
      })
    },
    openQc3Link(row) {
      API.service.GET_LINK3({id: row.id, a_customer_id: row.a_customer_id }).then(res => {
        if (res.data.code == 1) {
          navigator.clipboard.writeText( res.data.data.link)
          console.log(res.data.data.link)
          this.$message.success("参数已复制");
        }else{
          this.$message.error("获取失败");
        }
      })
    },
  },
  mounted() {
    this.getList()
  }
}
</script>
<style scoped>
.inputs {
  display: inline-block;
  width: 70px
}
</style>
